<template>
  <div>
    <BaseCard
      :has-divider="true"
      :has-main-container="true"
      base-card-title-class="app-font-semibold title mb-1"
    >
      <template v-slot:header-title>
        <BaseButton
          color="primary"
          type="text"
          class="ma-0 mr-2"
          @click="$emit('onClose')"
        >
          <v-icon small>
            mdi-arrow-left
          </v-icon>
          Voltar
        </BaseButton>
        Histórico de versão
      </template>
      <v-row>
        <v-col cols="9">
          <div
            v-if="processorLogList.length"
            class="pb-4 px-2"
          >
            <span class="body-2">
              {{ parseLogPayload(lastProcessorLog, 'alias') }} ({{ parseLogPayload(lastProcessorLog, 'processorName') }})
            </span>
            <span class="body-2">
              <strong>{{ parseAction(lastProcessorLog.action) }} em {{ lastProcessorLog.timestamp | getDate }} - {{ lastProcessorLog.timestamp | getFullTime }}</strong>
            </span>
            <v-row class="mt-8">
              <v-col
                class="pa-0 text-center"
              >
                <strong v-if="lastProcessorLog && lastProcessorLog.timestamp">
                  {{ lastProcessorLog.timestamp | getDate }} - {{ lastProcessorLog.timestamp | getFullTime }}
                </strong>
              </v-col>
              <v-col
                class="pa-0 text-center"
              >
                <strong v-if="newProcessorLog && newProcessorLog.timestamp">
                  {{ newProcessorLog.timestamp | getDate }} - {{ newProcessorLog.timestamp | getFullTime }}
                </strong>
              </v-col>
            </v-row>
            <CodeDiff
              :old-string="lastProcessorLog.diff"
              :new-string="newProcessorLog.diff"
              language="JSON"
              output-format="side-by-side"
            />
          </div>
          <div
            v-else
            class="empty-state"
          >
            <img
              src="@/assets/no-file-select.svg"
              width="200"
            >
            <p class="mt-4 grey--text text--darken-1">
              Nenhum histórico selecionado
            </p>
          </div>
        </v-col>

        <v-divider vertical />

        <v-col cols="3">
          <v-virtual-scroll
            v-if="processorLogList.length"
            :items="processorLogList"
            height="600"
            item-height="100"
            class="mb-4 pb-2"
          >
            <template v-slot:default="{ item }">
              <v-card
                elevation="0"
                class="pa-2 my-2"
                active-class="log-item--selected"
                @click="selectLog(item)"
              >
                <div class="app-align-items-center mb-3">
                  <p class="font-weight-bold body-1">
                    {{ item.timestamp | getDate }} - {{ item.timestamp | getFullTime }}
                  </p>
                  <v-spacer />
                  <v-chip x-small>
                    {{ parseAction(item.action) }}
                  </v-chip>
                </div>
                <p class="body-1">
                  {{ parseInitiatedBy(item) }}
                </p>
              </v-card>
            </template>
          </v-virtual-scroll>
          <div
            v-else
            class="text-center my-12"
          >
            Nenhum histórico encontrado.
          </div>
        </v-col>
      </v-row>
    </BaseCard>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import { CodeDiff } from 'v-code-diff'

export default {
  components: { CodeDiff },
  props: {
    context: {
      type: String,
      required: false,
      default: null
    },
    idOfItemToOpen: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      newProcessorLog: {
        diff: ''
      },
      lastProcessorLog: {
        diff: ''
      },
      processorLogList: []
    }
  },
  async created(){
    this.getProcessorLogs()
  },
  methods: {
    ...mapActions(['apiGetRulesLogs']),
    async getProcessorLogs(){
      try {
        let result = await this.apiGetRulesLogs({
          entityId: this.idOfItemToOpen,
          context: "ProcessorConfiguration",
          params: ""
        })
        this.processorLogList = result.content ? result.content : []
        this.lastProcessorLog = {
          ...this.processorLogList[0],
          diff:  this.stringifyValue(JSON.parse(this.processorLogList[0].data.payload))
        }
      } catch (error) {
        this.showFeedback({
          message: `Erro ao buscar histórico de versão.`,
          color: 'error'
        })
      }
    },
    selectLog(item){
      this.newProcessorLog = {
        ...item,
        diff: this.stringifyValue(JSON.parse(item.data.payload))
      }
    },
    parseLogPayload(item, key){
      let payload = item.data && item.data.payload ? JSON.parse(item.data.payload) : null
      return payload && payload[key] ? payload[key] : '-'
    },
    parseAction(action){
      const parseAction = {
        "delete": "apagado",
        "update": "atualizado",
        "create": "criado"
      }
      return parseAction[action] || action
    }
  }
}
</script>

<style scoped>
.empty-state {
  height: 100%;
  min-height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.log-item--selected {
  background: #40756d1f;
  color: var(--v-primary-base);
  font-weight: 600;
}
</style>
